import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  currentProduct: {},
  currentSku: {},
  priceTracking: {
    sellers: {
      all: [],
      checked: []
    },
    chartOptions: {
      status: {
        loading: false,
        noData: false
      },
      chart: {
        id: 'price-alternation-chart',
        toolbar: {
          show: false
        }
      },
      legend: {
        show: false,
        horizontalAlign: 'left'
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        curve: 'smooth',
        lineCap: 'butt',
        width: 2.5,
        dashArray: 0
      },
      colors: ['#56e2cf', '#56aee3', '#307fff', '#5668e2', '#cf55e2', '#e356ae', '#e25567', '#e28955', '#e2cf56', '#aee255'],
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'vertical',
          shadeIntensity: 0.2,
          inverseColors: true,
          opacityFrom: 0.4,
          opacityTo: 0,
          stops: [0, 80]
        }
      },
      grid: {
        strokeDashArray: 3
      },
      xaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        categories: []
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
        formatter: (value) => { return value },
        axisBorder: {
          show: false
        }
      },
      series: []
    }
  },
  availabilityTracking: {
    sellers: {
      all: [],
      checked: []
    },
    chartOptions: {
      status: {
        loading: false,
        noData: false
      },
      chart: {
        id: 'availability-tracking-chart',
        toolbar: {
          show: false
        },
        offsetX: 5
      },
      legend: {
        show: false
      },
      tooltip: {
        enabled: true
      },
      dataLabels: {
        enabled: false,
        onDatasetHover: {
          highlightDataSeries: true
        }
      },
      stroke: {
        show: true,
        curve: 'stepline',
        lineCap: 'butt',
        colors: undefined,
        width: 2.5,
        dashArray: 0
      },
      colors: ['#56e2cf', '#56aee3', '#307fff', '#5668e2', '#cf55e2', '#e356ae', '#e25567', '#e28955', '#e2cf56', '#aee255'],
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'vertical',
          shadeIntensity: 0.2,
          inverseColors: true,
          opacityFrom: 0.4,
          opacityTo: 0,
          stops: [0, 80]
        }
      },
      grid: {
        strokeDashArray: 3
      },
      xaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        categories: []
      },
      yaxis: {
        show: true,
        showAlways: true,
        opposite: false,
        reversed: false,
        logarithmic: false,
        tickAmount: 2,
        min: 0,
        max: 2,
        forceNiceScale: false,
        floating: false,
        decimalsInFloat: 2,
        labels: {
          show: true,
          align: 'right',
          minWidth: 0,
          offsetX: 0,
          offsetY: 0,
          rotate: -45
        },
        axisBorder: {
          show: false
        }
      },
      series: []
    }
  },
  sellersTable: {
    items: [],
    loading: false
  },
  oldTable: {
    items: [],
    loading: false
  },
  products: [],
  skus: [],
  reportSellers: [],
  reportSKU: undefined
}

const getters = {

}

let elemRef = null
let elem2Ref = null

const actions = {
  getProduct ({commit}, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getProduct',
        payload: {
          product_name: filter.productName,
          sku: filter.sku,
          page_id: filter.pageId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_products', response.data.payload.product)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getSku ({commit}, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getSku',
        payload: {
          sku: filter.sku,
          page_id: filter.pageId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_skus', response.data.payload.sku_result)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getPriceTracking ({commit}, filter) {
    commit('SET_loading_priceTracking', true)
    elemRef = filter.chartRef
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'productViewModule',
        payload: {
          product_id: filter.productId,
          sku: filter.sku,
          seller_id: filter.sellerId,
          alt_date: filter.altDate,
          module_id: filter.moduleId
        }
      })
        .then(response => {
          console.log('Price Tracking', response.data.payload)
          if (response.data.payload) {
            commit('SET_noData_priceTracking', false)
            commit('SET_loading_priceTracking', false)
            commit('SET_priceTracking', {categories: response.data.payload.categories, series: response.data.payload.series})
            if (filter.sellerId === 0) {
              commit('SET_priceTrackingSellers', {sellers: response.data.payload.sellers})
            }
            resolve(1)
          } else {
            commit('SET_loading_priceTracking', false)
            commit('SET_noData_priceTracking', true)
            resolve(0)
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getAvailabilityTracking ({commit}, filter) {
    commit('SET_loading_avaliabilityTracking', true)
    elem2Ref = filter.chartRef
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'productViewModule',
        payload: {
          product_id: filter.productId,
          sku: filter.sku,
          seller_id: filter.sellerId,
          alt_date: filter.altDate,
          module_id: filter.moduleId
        }
      })
        .then(response => {
          console.log('Availability Tracking', response.data.payload)
          if (response.data.payload.series && response.data.payload.series.length > 0) {
            commit('SET_loading_avaliabilityTracking', false)
            commit('SET_noData_avaliabilityTracking', false)
            commit('SET_availabilityTracking', {categories: response.data.payload.categories, series: response.data.payload.series, sellers: response.data.payload.sellers})
            if (filter.sellerId === 0) {
              commit('SET_availabilityTrackingSellers', {sellers: response.data.payload.sellers})
            }
            resolve(1)
          } else {
            commit('SET_loading_avaliabilityTracking', false)
            commit('SET_noData_avaliabilityTracking', true)
            resolve(0)
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getAvailabilityTrackingSellers ({commit}, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getSeller',
        payload: {
          seller_name: filter.sellerName,
          product_id: filter.productId,
          sku: filter.sku,
          date_option: filter.dateOption,
          page_id: filter.pageId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_availabilityTrackingSellers', response.data.payload.sellers)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getSellerTable ({commit}, filter) {
    commit('SET_tableSellers_loading', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'productViewModule',
        payload: {
          product_id: filter.productId,
          sku: filter.sku,
          module_id: filter.moduleId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_tableSellers', response.data.payload.sellers)
            commit('SET_reportSKU', response.data.payload.sellers)
            commit('SET_tableSellers_loading', false)
            commit('SET_reportSellers', response.data.payload.sellers)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
          commit('SET_tableSellers_loading', false)
        })
    })
  }
}

const mutations = {
  SET_loading_priceTracking (state, bool) {
    state.priceTracking.chartOptions.status.loading = bool
  },
  SET_noData_priceTracking (state, bool) {
    state.priceTracking.chartOptions.status.noData = bool
    if (bool === true) {
      state.priceTracking.chartOptions.series = []
      state.priceTracking.sellers.all = []
    }
  },
  SET_loading_avaliabilityTracking (state, bool) {
    state.availabilityTracking.chartOptions.status.loading = bool
  },
  SET_noData_avaliabilityTracking (state, bool) {
    state.availabilityTracking.chartOptions.status.noData = bool
    if (bool === true) {
      state.availabilityTracking.chartOptions.series = []
      state.availabilityTracking.sellers.all = []
    }
  },
  SET_products (state, data) {
    state.products = data
  },
  SET_skus (state, data) {
    state.skus = data
  },
  SET_currentProduct (state, data) {
    state.currentProduct = data.object
  },
  SET_resetCurrentProduct (state) {
    state.currentProduct = {}
    state.currentProduct.id = 0
  },
  SET_currentSku (state, data) {
    state.currentSku = {}
    state.currentSku = data.object
  },
  SET_resetCurrentSku (state) {
    state.currentSku.sku = ''
  },
  SET_priceTrackingSellers (state, data) {
    state.priceTracking.sellers.all = []
    state.priceTracking.sellers.checked = []
    state.priceTracking.sellers.all = data.sellers
    data.sellers.forEach(el => {
      if (el.checked) {
        return state.priceTracking.sellers.checked.unshift(el.id)
      }
    })
  },
  ADD_priceTrackingSellers (state, data) {
    state.priceTracking.sellers.checked = null
    state.priceTracking.sellers.checked = data.item
  },
  SET_priceTracking (state, data) {
    if (data.series && data.categories) {
      let seriesNumber = data.series.map(e => {
        return {name: e.name, data: e.data ? e.data.map(e => Number(e)) : 0}
      })
      state.priceTracking.chartOptions.xaxis.categories = data.categories
      state.priceTracking.chartOptions.series = seriesNumber
      if (elemRef) {
        elemRef.refresh()
      }
    } else {
      state.priceTracking.chartOptions.xaxis.categories = []
      state.priceTracking.chartOptions.series = [{name: '', data: ''}]
      state.priceTracking.chartOptions.status.noData = true
      if (elemRef) {
        elemRef.refresh()
      }
    }
  },
  SET_priceTracking_loading (state, bool) {
    state.priceTracking.loading = bool
  },
  SET_availabilityTrackingSellers (state, data) {
    state.availabilityTracking.sellers.all = []
    state.availabilityTracking.sellers.all = data.sellers
    data.sellers.forEach(el => {
      if (el.checked) {
        return state.availabilityTracking.sellers.checked.unshift(el.id)
      }
    })
  },
  SET_availabilityTracking (state, data) {
    if (data.series && data.categories) {
      let seriesNumber = data.series.map(e => {
        return {name: e.name, data: e.data ? e.data.map(e => Number(e)) : 0}
      })
      state.availabilityTracking.chartOptions.xaxis.categories = data.categories
      state.availabilityTracking.chartOptions.series = seriesNumber
      if (elem2Ref) {
        elem2Ref.refresh()
      }
    } else {
      state.availabilityTracking.chartOptions.xaxis.categories = []
      state.availabilityTracking.chartOptions.series = [{name: '', data: ''}]
      if (elem2Ref) {
        elem2Ref.refresh()
      }
    }
    state.availabilityTracking.sellers.all = data.sellers
  },
  ADD_availabilityTrackingSellers (state, data) {
    state.availabilityTracking.sellers.checked = null
    state.availabilityTracking.sellers.checked = data.item
  },
  SET_availabilityTracking_loading (state, bool) {
    state.availabilityTracking.loading = bool
  },
  SET_tableSellers (state, data) {
    state.sellersTable.items = []
    state.oldTable.items = []
    data.map(el => {
      if (el.price_status === 0 || el.price_status === 1 || el.price_status === 2 || el.price_status === 3) {
        state.sellersTable.items.push(el)
      } else {
        state.oldTable.items.push(el)
      }
    })
  },
  SET_tableSellers_loading (state, bool) {
    state.sellersTable.loading = bool
  },
  SET_reportSellers (state, data) {
    let sellers = []
    data.map(el => {
      sellers.push({ id: el.seller_id, name: el.seller_name })
    })
    state.reportSellers = sellers
  },
  SET_reportSKU (state, data) {
    for (let seller of data) {
      if (seller.my_seller === '1') {
        state.reportSKU = seller.sku
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/productview.js